import { Box, Typography, IconButton } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import CloseIcon from "@mui/icons-material/Close";

export const SideDrawer = ({
  open,
  onClose,
  title,
  optionalHeader,
  children,
}) => (
  <Drawer
    anchor="right"
    open={open}
    onClose={onClose}
    slotProps={{
      paper: {
        sx: {
          width: "80vw",
          maxWidth: 1000,
          p: 2,
          display: "flex",
          flexDirection: "column",
        },
      },
    }}
  >
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        rowGap: 0.5,
        columnGap: 1.5,
        mb: 2,
        flexShrink: 0,
      }}
    >
      <Typography variant="h6" sx={{ minWidth: 0, overflowWrap: "anywhere" }}>
        {title}
      </Typography>
      {optionalHeader}
      <Box sx={{ flexGrow: 1 }} />
      <IconButton aria-label="Close details" onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Box>
    {/* Scrollable content area so long detail views aren't clipped by the
        viewport; the header above stays fixed. minHeight:0 lets this flex
        child shrink enough to actually scroll. */}
    <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>{children}</Box>
  </Drawer>
);
